module.exports = __webpack_public_path__ + "double-fc6-mobile.jpg";